import { SVGProps } from 'react'

export const RectRoundCheckbox5 = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0C14.588 0 16 1.412 16 8C14.6667 14.6667 8 16 8 16C8 16 1.33333 14.6667 0 8C0 1.412 1.412 -1.27532e-06 8 0ZM11.1381 5.52861C11.3984 5.78896 11.3984 6.21107 11.1381 6.47141L7.80475 9.80475C7.5444 10.0651 7.12229 10.0651 6.86194 9.80475L5.52861 8.47141C5.26826 8.21107 5.26826 7.78896 5.52861 7.52861C5.78896 7.26826 6.21107 7.26826 6.47141 7.52861L7.33334 8.39053L10.1953 5.52861C10.4556 5.26826 10.8777 5.26826 11.1381 5.52861Z"
        fill="#FFC837"
      />
    </svg>
  )
}
